import {
    Badge,
    Banner,
    Button,
    ButtonGroup,
    Card,
    Checkbox,
    DataTable,
    EmptyState,
    Heading,
    Icon,
    OptionList,
    Page,
    Scrollable,
    Sheet,
    Spinner,
    Stack,
    TextField,
    TextStyle,
    Thumbnail,
} from "@shopify/polaris"
import { CancelSmallMinor, DeleteMinor, EditMinor, SearchMinor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import InfinitScroll from "react-infinite-scroll-component"
import axios from "../../funcs/axios"
import "./style.scss"
export default class SingleProduct extends Component {
    state = {
        listCheckbox: [],
        checkAll: false,
        sheetActive: false,
        selected: [],
        all_product: [],
        loading: true,
        loadingEndPoint: false,
        nextCursor: "",
        textSearch: "",
        listPreOrder: [],
        loaded: false,
        searchSingleProduct: "",
        showBanner: true,
    }

    constructor(props: Props) {
        super(props)
        this.scrollBottom = React.createRef()
        this.loadPreOrder()
        this.handleGetProduct()
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return
        }
    }

    loadPreOrder = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-all-pre-order`).then((res) => {
            if (res.data.status == "success") {
                this.setState({ listPreOrder: res.data.preOrder, loaded: true })
            } else {
                this.setState({ listPreOrder: [], loaded: true })
            }
        })
    }

    handleDeletePreOrder = (index) => {
        const { listPreOrder } = this.state
        let id = listPreOrder[index].id
        listPreOrder.splice(index, 1)
        this.setState({ listPreOrder })
        axios.delete(`${window.SHOPIFY_APP_HOST}/admin/delete-pre-order/${id}`).then((res) => {
            console.log("bbbb", res)
        })
    }

    handleDeleteList = () => {
        const { listCheckbox, listPreOrder } = this.state
        console.log("aaaa")
        for (let i = 0; i < listCheckbox.length; i++) {
            let index = listPreOrder.find((item) => item.id == listCheckbox[i].id)
            listPreOrder.splice(index, 1)
            axios
                .delete(`${window.SHOPIFY_APP_HOST}/admin/delete-pre-order/${listCheckbox[i].id}`)
                .then((res) => {
                    console.log("bbbb", res)
                })
        }
        this.setState({ listPreOrder, listCheckbox: [] })
        console.log("listCheckbox", listCheckbox)
    }

    // handleCheckbox

    handleCheckAll = () => {
        const { checkAll, listPreOrder } = this.state
        let newListCheckbox = []
        if (!checkAll) {
            listPreOrder.map((item, index) => {
                let data = {
                    id: item.id,
                }
                return newListCheckbox.push(data)
            })
        }
        this.setState({ listCheckbox: newListCheckbox })
        this.setState({ checkAll: !checkAll })
    }

    checkItemExistsInArray = (array, id) => {
        if (!array.length) return false
        for (let i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return true
            }
        }
        return false
    }

    handleChangeProductsSelected = (id) => {
        const { listCheckbox, listPreOrder } = this.state
        let newListCheckbox = [...listCheckbox]
        let data = {
            id,
        }
        let flag = this.checkItemExistsInArray(newListCheckbox, id)
        if (flag) {
            newListCheckbox = newListCheckbox.filter((item) => item.id != id)
        } else {
            newListCheckbox.push(data)
        }
        if (newListCheckbox.length === listPreOrder.length) this.setState({ checkAll: true })
        else this.setState({ checkAll: false })
        this.setState({ listCheckbox: newListCheckbox })
    }

    // end handleCheckbox

    handleToggleSheetActive = () => {
        const { sheetActive } = this.state
        this.setState({ sheetActive: !sheetActive })
    }

    handleLoadMore = () => {
        const { all_product } = this.state
        if (this.state.nextCursor) {
            let rows = [...all_product]
            axios
                .get(
                    `${window.SHOPIFY_APP_HOST}/admin/search-product?type=product&nextPage=${this.state.nextCursor}`,
                )
                .then((res) => {
                    let data = res.data.list
                    console.log("dataaaaa", res.data)
                    data.map((item) => {
                        return rows.push({
                            value: item.id,
                            label: (
                                <div className="productInfo">
                                    <Thumbnail
                                        source={item.featured_image}
                                        size="small"
                                        alt={item.title}
                                    />
                                    <h3 className="productName">
                                        <TextStyle variation="strong">{item.title}</TextStyle>
                                    </h3>
                                </div>
                            ),
                        })
                    })
                    if (res.data.nextUrl) {
                        this.setState({ nextCursor: res.data.nextUrl })
                    } else {
                        this.setState({ nextCursor: "" })
                    }
                    this.setState({ all_product: rows, loading: false, loadingEndPoint: true })
                })
        } else {
            this.setState({ loadingEndPoint: false })
        }
    }

    handleGetProduct = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/search-product?type=product`).then((res) => {
            let data = res.data.list
            let rows = []
            data.map((item) => {
                return rows.push({
                    value: item.id,
                    label: (
                        <div className="productInfo">
                            <Thumbnail source={item.featured_image} size="small" alt={item.title} />
                            <h3 className="productName">
                                <TextStyle variation="strong">{item.title}</TextStyle>
                            </h3>
                        </div>
                    ),
                })
            })
            if (res.data.nextUrl) {
                this.setState({ nextCursor: res.data.nextUrl })
            } else {
                this.setState({ nextCursor: "" })
            }
            this.setState({ all_product: rows, loading: false, loadingEndPoint: true })
        })
    }

    handleSearchSingleProduct = (val) => {
        this.setState({ searchSingleProduct: val })
    }

    handleSearch = (val) => {
        let url = `${window.SHOPIFY_APP_HOST}/admin/search-product?search=${val}&type=product`
        this.setState({ textSearch: val })
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        if (!val) {
            url = `${window.SHOPIFY_APP_HOST}/admin/search-product?type=product`
        }
        this.searchTimeout = setTimeout(() => {
            axios.get(url).then((res) => {
                let data = res.data.list
                let rows = []
                data.map((item) => {
                    return rows.push({
                        value: item.id,
                        label: (
                            <div className="productInfo">
                                <Thumbnail
                                    source={item.featured_image}
                                    size="small"
                                    alt={item.title}
                                />
                                <h3 className="productName">
                                    <TextStyle variation="strong">{item.title}</TextStyle>
                                </h3>
                            </div>
                        ),
                    })
                })
                if (res.data.nextUrl) {
                    this.setState({ nextCursor: res.data.nextUrl })
                } else {
                    this.setState({ nextCursor: "" })
                }
                this.setState({ all_product: rows, loading: false, loadingEndPoint: false })
            })
        }, 500)
    }

    //HANDLE OPEN PRODUCT
    handleOpenProduct = (selected) => {
        this.setState({ selected: selected })
        console.log(selected)
        this.props.redirectToPage("SingleProductDetail", selected[0])
    }

    //Higher-order function
    searched = (keyword) => (e) => e.name.toLowerCase().includes(keyword.toLowerCase())
  
    render() {
        const {
            checkAll,
            listCheckbox,
            sheetActive,
            loading,
            selected,
            all_product,
            textSearch,
            loaded,
            searchSingleProduct,
            showBanner,
        } = this.state
        let { listPreOrder } = this.state
        let rows = [],
            heading = [
                <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />,
                "Product",
                "Status",
                "Action",
            ]
        console.log("listCheckbox", listCheckbox)
        console.log("listPreOrder", listPreOrder)
        listPreOrder = listPreOrder.filter(this.searched(searchSingleProduct))
        for (let i = 0; i < listPreOrder.length; i++) {
            let array = []
            array.push(
                <Checkbox
                    onChange={() => this.handleChangeProductsSelected(listPreOrder[i].id)}
                    checked={this.checkItemExistsInArray(listCheckbox, listPreOrder[i].id)}
                />,
            )
            array.push(
                <div className="productInfo">
                    <Thumbnail
                        source={listPreOrder[i].image.src}
                        size="small"
                        alt="Black choker necklace"
                    />
                    <h3
                        className="productName"
                        onClick={() =>
                            this.props.redirectToPage("SingleProductDetail", listPreOrder[i].id)
                        }
                    >
                        <TextStyle variation="strong">{listPreOrder[i].name}</TextStyle>
                    </h3>
                </div>,
            )
            array.push(
                <div className={listPreOrder[i].status ? "status-enable" : ""}>
                    <Badge progress="complete" className="Badge-enbale">
                        {listPreOrder[i].status ? "Enable" : "Disabled"}
                    </Badge>
                </div>,
            )
            array.push(
                <ButtonGroup segmented>
                    <Button
                        icon={<Icon source={EditMinor} />}
                        onClick={() =>
                            this.props.redirectToPage("SingleProductDetail", listPreOrder[i].id)
                        }
                        size="slim"
                    ></Button>
                    <Button
                        destructive
                        icon={<Icon source={DeleteMinor} />}
                        size="slim"
                        onClick={() => this.handleDeletePreOrder(i)}
                    ></Button>
                </ButtonGroup>,
            )
            rows.push(array)
        }

        if (listCheckbox.length) {
            heading = []
            heading.push(
                <ButtonGroup segmented>
                    <Button
                        icon={
                            <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />
                        }
                        onClick={() => this.handleCheckAll()}
                    >
                        {listCheckbox.length} selected
                    </Button>
                    <Button
                        destructive
                        icon={<Icon source={DeleteMinor} />}
                        onClick={() => this.handleDeleteList()}
                    >
                        Delete
                    </Button>
                </ButtonGroup>,
            )

            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.setAttribute("colspan", 4)
            }
        } else {
            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.removeAttribute("colspan")
            }
        }
        console.log("listPreOrder.length", listPreOrder.length)
        return (
            <>
                <Page
                    title="Single Product"
                    primaryAction={{
                        content: "Add product",
                        onAction: () => this.handleToggleSheetActive(),
                    }}
                >
                    {showBanner && (
                        <Banner
                            status="info"
                            onDismiss={() => this.setState({ showBanner: false })}
                        >
                            <p>
                                You can enable pre-order for separate product in this page. If you
                                want to configure pre-order feature for a group of products, click
                            </p>
                        </Banner>
                    )}

                    {loaded ? (
                        <div style={{ marginTop: "2rem" }}>
                            <Card>
                                <Card.Section>
                                    <TextField
                                        value={searchSingleProduct}
                                        onChange={(val) => this.handleSearchSingleProduct(val)}
                                        placeholder="Search products"
                                        type="search"
                                        prefix={<Icon source={SearchMinor} />}
                                    ></TextField>
                                </Card.Section>
                                {listPreOrder.length ? (
                                    <Card.Section>
                                        <DataTable
                                            columnContentTypes={["text", "text", "text", "text"]}
                                            headings={heading}
                                            rows={rows}
                                        ></DataTable>
                                    </Card.Section>
                                ) : (
                                    <Card>
                                        <Card.Section>
                                            <EmptyState
                                                heading="No product in pre-order"
                                                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                                            >
                                                <p>
                                                    We couldn't find any result. Please add to
                                                    product pre-order
                                                </p>
                                            </EmptyState>
                                        </Card.Section>
                                    </Card>
                                )}
                            </Card>
                        </div>
                    ) : (
                        <Stack distribution="center">
                            <div style={{ marginTop: "20px", display: "flex" }}>
                                <Spinner
                                    accessibilityLabel="Loading more customers"
                                    size="large"
                                    color="teal"
                                />
                            </div>
                        </Stack>
                    )}

                    {/* Sheet  */}

                    <Sheet open={sheetActive} onClose={() => this.handleToggleSheetActive()}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                            }}
                        >
                            <div
                                style={{
                                    alignItems: "center",
                                    borderBottom: "1px solid #DFE3E8",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "1.6rem",
                                    width: "100%",
                                }}
                            >
                                <Heading>Select Product</Heading>
                                <Button
                                    accessibilityLabel="Cancel"
                                    icon={CancelSmallMinor}
                                    onClick={() => this.handleToggleSheetActive()}
                                    plain
                                />
                            </div>
                            <TextField
                                placeholder="Search products"
                                type="search"
                                onChange={(val) => this.handleSearch(val)}
                                value={textSearch}
                                prefix={<Icon source={SearchMinor} />}
                            ></TextField>

                            <Scrollable
                                id="scrollableDiv"
                                style={{ marginTop: "1.6rem", height: "100%" }}
                            >
                                {loading ? (
                                    <Stack distribution="center">
                                        <div style={{ marginTop: "20px", display: "flex" }}>
                                            <Spinner
                                                accessibilityLabel="Loading more customers"
                                                size="large"
                                                color="teal"
                                            />
                                        </div>
                                    </Stack>
                                ) : (
                                    <InfinitScroll
                                        dataLength={all_product.length}
                                        hasMore={true}
                                        next={() => this.handleLoadMore()}
                                        scrollableTarget="scrollableDiv"
                                        loader={
                                            this.state.loadingEndPoint ? (
                                                <Stack distribution="center">
                                                    <svg viewBox="0 0 80 80" height="48" width="48">
                                                        <path
                                                            id="spinner"
                                                            fill="#81D8D8"
                                                            d="M40,72C22.4,72,8,57.6,8,40C8,22.4,
                                                        22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2
                                                        s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,
                                                        28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z"
                                                        >
                                                            <animateTransform
                                                                attributeType="xml"
                                                                attributeName="transform"
                                                                type="rotate"
                                                                from="0 40 40"
                                                                to="360 40 40"
                                                                dur="0.6s"
                                                                repeatCount="indefinite"
                                                            ></animateTransform>
                                                        </path>
                                                    </svg>
                                                </Stack>
                                            ) : null
                                        }
                                    >
                                        <div>
                                            <OptionList
                                                onChange={(val) => this.handleOpenProduct(val)}
                                                options={all_product}
                                                selected={selected}
                                            />
                                        </div>
                                    </InfinitScroll>
                                )}
                            </Scrollable>

                            <div
                                style={{
                                    alignItems: "center",
                                    borderTop: "1px solid #DFE3E8",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "1.6rem",
                                    width: "100%",
                                }}
                            >
                                <Button onClick={() => this.handleToggleSheetActive()}>
                                    Cancel
                                </Button>
                                <Button primary onClick={() => this.handleToggleSheetActive()}>
                                    Done
                                </Button>
                            </div>
                        </div>
                    </Sheet>
                </Page>
            </>
        )
    }
}
